export default __webpack_public_path__ + "static/media/connectedIcon.5e1769af.svg";